import { ISearch } from './ISearch.model';

export class Client implements ISearch {
  public name: string;
  public clientNumber: string;
  search(query: string) {
    const queryToLower = query.toLowerCase();
    return this.name?.toLowerCase()?.includes(queryToLower) || this.clientNumber?.toLowerCase()?.includes(queryToLower);
  }
}
